import { render } from "./PrivacyTitle.vue?vue&type=template&id=3b55392a&scoped=true"
import script from "./PrivacyTitle.vue?vue&type=script&lang=js"
export * from "./PrivacyTitle.vue?vue&type=script&lang=js"

import "./PrivacyTitle.vue?vue&type=style&index=0&id=3b55392a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b55392a"]])

export default __exports__